import _ from 'lodash';

import { assetsMap, incomeMap, typeOfCreditMap } from 'constants/options';
import { formatNumberToCurrencyString } from 'utils/number';

export const getLiabilityName = liability =>
  liability.creditorName ??
  typeOfCreditMap[liability.liabilityAccountType ?? liability.liabilityExpenseType]?.name ??
  'Unknown';

export const getLiabilityLabel = liability => {
  const name = getLiabilityName(liability);

  if (!_.isFinite(Number(liability.unpaidBalance))) {
    return name;
  }

  const balance = formatNumberToCurrencyString(liability.unpaidBalance, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return `${name} | ${balance}`;
};

export const getIncomeName = income =>
  income.employerName && !income.endDate
    ? income.employerName
    : (incomeMap[income.incomeType]?.name ?? 'Unknown');

export const getIncomeLabel = income => {
  const name = getIncomeName(income);

  if (!_.isFinite(Number(income.monthlyIncome))) {
    return name;
  }

  const amount = formatNumberToCurrencyString(income.monthlyIncome);

  return `${name} | ${amount}/mo`;
};

export const getAssetName = asset =>
  asset.institution ?? assetsMap[asset.assetTypeName]?.name ?? 'Unknown';

export const getAssetLabel = asset => {
  const name = getAssetName(asset);

  if (!_.isFinite(Number(asset.balance))) {
    return name;
  }

  const balance = formatNumberToCurrencyString(asset.balance);

  return `${name} | ${balance}`;
};
